import setUpdateCartLoading from "@NA/Handlers/ADIUpdateCartLoadingHandler";
import { getUserDetails } from "@NA/Services/ADIXtenIntegrationService";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import loadCurrentPromotions from "@insite/client-framework/Store/Data/Promotions/Handlers/LoadCurrentPromotions";
import { getCurrentPromotionsDataView } from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import loadWishLists from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishLists";
import setIsPreloadingData from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetIsPreloadingData";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import Page from "@insite/mobius/Page";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { Component } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends PageProps {}

const mapDispatchToProps = {
    loadCurrentCart,
    loadCurrentPromotions,
    setIsPreloadingData,
    loadWishLists,
};

const mapStateToProps = (state: CustomApplicationState) => {
    const currentPromotionsDataView = getCurrentPromotionsDataView(state);
    const cartState = getCurrentCartState(state);
    return {
        cart: getCurrentCartState(state),
        shouldLoadPromotions: !currentPromotionsDataView.value && !currentPromotionsDataView.isLoading,
        isPreloadingData: state.pages.checkoutShipping.isPreloadingData,
        session: getSession(state),
        isCartLoading: state.ADIGlobalData.ADIUpdateCartLoading.loading || cartState.isLoading,
    };
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface CartPageStyles {
    loadingOverlay?: LoadingOverlayProps;
    mainContainer?: InjectableCss;
    lowerContainer?: InjectableCss;
}

export const cartPageStyles: CartPageStyles = {
    loadingOverlay: {
        css: css`
            & > div:first-child[data-loading="true"] {
                position: fixed;
            }
        `,
    },
    mainContainer: {
        css: css`
            font-size: 20px;
            line-height: 25px;
            color: #000;
            font-weight: 400;
            margin-bottom: 10px;
        `,
    },
    lowerContainer: {
        css: css`
            font-size: 16px;
            line-height: 24px;
            color: #000;
            font-weight: 400;
        `,
    },
};

class CartPage extends Component<Props> {
    fetchUserDetails = async () => {
        try {
            const response = await getUserDetails();
            if (response) {
                localStorage.setItem("isXtenUserSignedUp", response.isUserSignedUp === true ? "true" : "false");
            }
        } catch (error) {
            console.error("Error fetching user details:", error);
        }
    };
    UNSAFE_componentWillMount() {
        const { shouldLoadPromotions, loadCurrentPromotions, isPreloadingData } = this.props;
        if (shouldLoadPromotions) {
            loadCurrentPromotions();
        }

        if (isPreloadingData) {
            this.props.setIsPreloadingData({ isPreloadingData: false });
        }
    }

    componentDidMount() {
        const { cart, loadCurrentCart, loadWishLists } = this.props;
        this.fetchUserDetails();
        if (!cart.isLoading) {
            sessionStorage.setItem("is_from_cart_page", "true");
            loadCurrentCart();
            loadWishLists({});
        }
    }

    getLoader() {
        const { isCartLoading } = this.props;
        if (isCartLoading) {
            return true;
        } else {
            return false;
        }
    }

    render() {
        const styles = cartPageStyles;
        const { session } = this.props;
        return (
            <Page>
                {(session && session.userRoles?.includes("FullAccess")) || !session.isAuthenticated ? (
                    <>
                        <LoadingOverlay {...styles.loadingOverlay} loading={this.getLoader()}>
                            <Zone contentId={this.props.id} zoneName="Content"></Zone>
                        </LoadingOverlay>
                        <Modals />
                    </>
                ) : (
                    <>
                        <StyledWrapper as="h2" {...styles.mainContainer}>
                            {"Unauthorized Access"}
                        </StyledWrapper>
                        <StyledWrapper {...styles.lowerContainer}>
                            {"We're sorry. You do not have permissions to view the page you are trying to visit."}
                        </StyledWrapper>
                    </>
                )}
            </Page>
        );
    }
}

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CartPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

export const CartPageContext = "CartPage";
